export { NotesDetails } from './NotesDetails'
